const LOG_TYPE_CRM = {
  id: 1,
  title: 'CRM',
  actions: {
    create: 'New Client Added',
    update: 'Client Amended',
    delete: 'Client Deleted'
  }
}

const LOG_TYPE_PAYMENT = {
  id: 2,
  title: 'Payment',
  actions: {
    create: 'Received',
    update: 'Amended',
    delete: 'Deleted'
  }
}

const LOG_TYPE_INVOICE = {
  id: 3,
  title: 'Invoice',
  actions: {
    create: 'Issued',
    update: 'Amended',
    delete: 'Deleted'
  }
}

const LOG_TYPE_SOA = {
  id: 4,
  title: 'SOA',
  actions: {
    create: 'Added',
    update: 'Amended',
    delete: 'Removed'
  }
}

const LOG_TYPE_PROJECT = {
  id: 5,
  title: 'List of Projects',
  actions: {
    create: 'Added',
    update: 'Amended',
    delete: 'Deleted',
    complete: 'Completed'
  }
}

const LOG_TYPE_REQUEST = {
  id: 6,
  title: 'List of requests',
  actions: {
    create: 'Added',
    update: 'Amended',
    delete: 'Deleted',
    complete: 'Completed',
    declined: 'Declined',
    forward: 'Take Forward'
  }
}

const LOG_TYPE_USER = {
  id: 7,
  title: 'User',
  actions: {
    login: 'Login',
    create: 'Added',
    update: 'Amended',
    delete: 'Deleted'
  }
}

export const CLIENT_HISTORY = {
  id: 8,
  title: 'Client Card > History',
  actions: {
    create: 'New Comment Added',
    update: 'Comment Amended',
    delete: 'Comment Deleted'
  }
}

export const CLIENT_COMPANY_HISTORY = {
  id: 9,
  title: 'Company Card > History',
  actions: {
    create: 'New Comment Added',
    update: 'Comment Amended',
    delete: 'Comment Deleted'
  }
}

export const COMPANY = {
  id: 10,
  title: 'Company',
  actions: {
    create: 'Added',
    delete: 'Deleted'
  }
}

const LOG_TYPES = [
  LOG_TYPE_CRM,
  LOG_TYPE_PAYMENT,
  LOG_TYPE_INVOICE,
  LOG_TYPE_SOA,
  LOG_TYPE_PROJECT,
  LOG_TYPE_REQUEST,
  LOG_TYPE_USER,
  CLIENT_HISTORY,
  CLIENT_COMPANY_HISTORY,
  COMPANY
]

const LOG_ACTION_CREATE = {id: 1, key: 'create', title: 'Added'}
const LOG_ACTION_UPDATE = {id: 2, key: 'update', title: 'Amended'}
const LOG_ACTION_DELETE = {id: 3, key: 'delete', title: 'Deleted'}
const LOG_ACTION_COMPLETE = {id: 4, key: 'complete', title: 'Completed'}
const LOG_ACTION_DECLINED = {id: 5, key: 'declined', title: 'Declined'}
const LOG_ACTION_FORWARD = {id: 6, key: 'forward', title: 'Take Forward'}
const LOG_ACTION_LOGIN = {id: 7, key: 'login', title: 'Login'}

const LOG_ACTIONS = [
  LOG_ACTION_CREATE,
  LOG_ACTION_UPDATE,
  LOG_ACTION_DELETE,
  LOG_ACTION_COMPLETE,
  LOG_ACTION_DECLINED,
  LOG_ACTION_FORWARD,
  LOG_ACTION_LOGIN
]

export {
  LOG_TYPES,
  LOG_ACTIONS,
  LOG_TYPE_PROJECT,
  LOG_TYPE_REQUEST,
  LOG_TYPE_USER,
  LOG_ACTION_CREATE,
  LOG_ACTION_UPDATE,
  LOG_ACTION_DELETE,
  LOG_ACTION_COMPLETE,
  LOG_ACTION_DECLINED
}



// WEBPACK FOOTER //
// ./src/constants/logTypes.js